import { FieldLabel } from "@braze/beacon-core";
import { Select } from "@braze/beacon-lab-select";
import { useState } from "react";
import { FormContainer } from "./FormContainer";
import { FieldProps } from "./types";

interface RequiredSelectProps extends FieldProps {
    options : {label:string, value:string}[];
    warningText? : string;
}
export const RequiredSelect = (props : RequiredSelectProps) => {
    const [invalid, setInvalid] = useState(true);
    return (
        
        <FormContainer>
            <FieldLabel label={props.name} status={invalid ? "danger":"success"} statusText={props.name+" "+(props.warningText || "Required")}>
                <Select
                    fluid
                    options={props.options}
                    invalid={invalid}
                    onChange={(value) => {
                        if (!value) {
                            setInvalid(true);
                            props.handleChange(value);
                        }
                        else {
                            setInvalid(false);
                            props.handleChange(value);
                        }
                    }}
                />
            </FieldLabel>
        </FormContainer>
    )
}